export const PrependZero = (number) => {
    if (number <= 9) return "0" + number + "00";
    else return number + "00";
}

